import React, { useState, useEffect } from 'react';
import { Table, Button, Drawer, KeyValuePairs, Icon, Modal, Checkbox, Link } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import TextFilter from '@cloudscape-design/components/text-filter';
import Pagination from '@cloudscape-design/components/pagination';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import Box from '@cloudscape-design/components/box';
import CollectionPreferences from '@cloudscape-design/components/collection-preferences';
import ButtonDropdown from '@cloudscape-design/components/button-dropdown';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { useStoreAdmin } from '../../../context/useStoreAdmin';

const pageSize = 40;

export const InvoiceIssuedPage = () => {
    const storeAdmin = useStoreAdmin();
  const { idPropiedad, setIdPropiedad } = useGlobalState();
  const { idControl, setIdControl } = useGlobalState();
  const [selectedRow, setSelectedRow] = useState<any>(null);  // Stores selected row data
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [btnAuths, setBtnAuths] = useState(true);
  const [btnSendEmailLoading, setBtnSendEmailLoading] = useState(false);
  const [selectedInvoices, setSelectedInvoices] = useState<string[]>([]);
  const { JWT, setJWT } = useGlobalState();

  const {
    actions: { makeHelpPanelHandler },
  } = useStore();
  const { navigate } = useRouter();
  const [selectedItems, setSelectedItems] = useState<InvoiceItem[]>([]);
  const { setLoading } = useGlobalState();
  const [btnSendEmailDisabled, setBtnSendEmailDisabled] = useState<boolean>(true);
  const [btnActionDisable, setBtnActionDisable] = useState<boolean>(true);
  const [currentPageIndex, setCurrentPageIndex] = useState(1);
  const [filteringText, setFilteringText] = useState('');
  const [emailHeader, setEmailHeader] = useState('');
  const [invoices, setInvoices] = useState<InvoiceItem[]>([]);
  const [isModalEmailOpen, setIsModalEmailOpen] = useState(false);
  const [admins, setAdmins] = useState<any[]>([]);
  const [selectedAdmins, setSelectedAdmins] = useState<any[]>([]);
  type InvoiceItem = {
    idFacturacion: number;
    fechaEmision: string;
    fechaVencimiento: string;
    fechaPago: string;
    neto: number;
    bruto: number;
    iva: number;
    rut: string;
    periodoIni: string;
    periodoFin: string;
    numDOC: number;
    dueDays: number;
    status: string;
    urlPDF: string;
    urlXML: string;
    hashFacturacion: string;
  };
  const handleCheckboxChange = (facturacionId: string) => {
    setSelectedInvoices((prev) => {
      // If the access is already selected, remove it from the array, else add it
      if (prev.includes(facturacionId)) {
        return prev.filter(id => id !== facturacionId);
      } else {
        return [...prev, facturacionId];
      }
    });
  };
  const filteredInvoices = invoices.filter(invoice => {
    const searchWords = filteringText.toLowerCase().split(/\s+/).filter(Boolean);
    return searchWords.every(word =>
      invoice.numDOC.toString().toLowerCase().includes(word) ||
      invoice.neto.toString().toLowerCase().includes(word)
    );
  });

  const paginatedInvoices = filteredInvoices.slice(
    (currentPageIndex - 1) * pageSize,
    currentPageIndex * pageSize
  );

  const handleSelectionChange = ({ detail }: any) => {
    setSelectedItems(detail.selectedItems);
    setBtnActionDisable(detail.selectedItems.length === 0);
    if (detail.selectedItems.length > 1) setDrawerOpen(false);
  };

  useEffect(() => {
    setBtnAuths(selectedInvoices.length == 0)
  }, [selectedInvoices]); // The effect runs every time selectedAccesses changes

  // Handle row click to fetch additional data and open the HelpPanel
  const handleDownloadMulti = (event: any) => {
    if (event.detail.id === 'download') {
      const hashFacturacion: string[] = [];
      selectedItems.forEach((item, index, array) => {
        hashFacturacion.push(item.hashFacturacion)
      })
      setLoading(true)
      const fileUrl = "https://api.llavemovil.com/services/downloads/invoices.aspx"; // selectedRow.hashInvoice
      fetch(fileUrl, {
        method: 'POST',
        body: JSON.stringify({
          type: 'all',
          hashFacturacion: hashFacturacion,
        })
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.blob(); // Get the response body as a Blob
        })
        .then(blob => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `DTE.33.SELECTED.zip` //suggestedFilename || 'downloaded_file'; // Set the desired filename
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a); // Clean up the temporary element
          URL.revokeObjectURL(url); // Clean up the Blob URL
          setLoading(false)
        })
        .catch(error => {
          console.error('Error downloading file:', error);
          setLoading(false)
          // Optionally display an error message to the user
        })
        .finally(() => {
          setLoading(false);
        })

    }
  }

  useEffect(() => {
    setBtnSendEmailDisabled(selectedAdmins.length == 0)
  }, [selectedAdmins]); // The effect runs every time selectedAccesses changes

  const handleChangeAdmins = (value: any) => (event: { detail: { checked: boolean } }) => {

    const checked = event.detail.checked;
    setSelectedAdmins(prevSelectedAccesses => {
      if (checked) {
        return [...prevSelectedAccesses, value];
      } else {
        return prevSelectedAccesses.filter(item => item !== value);
      }
    });
    console.log(selectedAdmins.length)
  };
  const handleRowClick = async (rowData: InvoiceItem) => {
    setSelectedRow(rowData);  // Store selected row data
    setLoading(true);
    try {
      // Simulate a fetch request to get additional data for the row
      // Example of a fetched data structure
      const invoiceDetails = {

        idFacturacion: rowData.idFacturacion,
        fechaEmision: rowData.fechaEmision,
        fechaVencimiento: rowData.fechaVencimiento,
        fechaPago: rowData.fechaPago,
        neto: rowData.neto,
        bruto: rowData.bruto,
        iva: rowData.iva,
        rut: rowData.rut,
        periodoIni: rowData.periodoIni,
        periodoFin: rowData.periodoFin,
        numDOC: rowData.numDOC,
        status: rowData.status,
        dueDays: rowData.dueDays,
        urlPDF: rowData.urlPDF,
        urlXML: rowData.urlXML,
        hashFacturacion: rowData.hashFacturacion,
      };

      const header = `DTE #${invoiceDetails.numDOC}`
      setEmailHeader(header)
      setSelectedRow(invoiceDetails);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
      setDrawerOpen(true);
    }
  };
  useEffect(() => {
  }, [selectedRow]);
  const handleRefresh = async () => {
    try {

      setLoading(true);
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/invoices/list',
          'JWT': JWT,

        },
        body: JSON.stringify({})
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      storeAdmin(data);
      setInvoices(data.invoices);

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    handleRefresh();
  }, []);
  const btnSendEmail = async () => {
    console.log("btnSendEmail")
    setBtnSendEmailLoading(true)

    const idControles: string[] = [];
    console.log(selectedAdmins)
    selectedAdmins.forEach((item, index, array) => {
      idControles.push(item.idControl)
    })
    try {
      setLoading(true)
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/invoices/email',
          'JWT': JWT,

        },
        body: JSON.stringify({
          hashFacturacion: [selectedRow.hashFacturacion],
          idControles: idControles
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();

      storeAdmin(data);
      if (data.JWTRenew && data.JWTRenew !== '') {

        setJWT(data.JWTRenew);
      }
      //setInvoices(data.invoices);


    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
      setIsModalEmailOpen(false)
    }
  }
  const handleEmail = async () => {
    setBtnSendEmailDisabled(true)
    setBtnSendEmailLoading(false)
    setSelectedAdmins([]);
    try {

      setLoading(true)
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/admins/list',
          'JWT': JWT,

        },
        body: JSON.stringify({})
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();

      storeAdmin(data);
      if (data.JWTRenew && data.JWTRenew !== '') {

        setJWT(data.JWTRenew);
      }
      //setInvoices(data.invoices);
      setIsModalEmailOpen(true)
      setAdmins(data.admins)


      console.log(idControl)


    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  }
  const handleDownload = (fileType: string) => {

    setLoading(true)
    const fileUrl = "https://api.llavemovil.com/services/downloads/invoices.aspx"; // selectedRow.hashInvoice
    fetch(fileUrl, {
      method: 'POST',
      body: JSON.stringify({
        type: fileType,
        hashFacturacion: [selectedRow.hashFacturacion],
      })
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.blob(); // Get the response body as a Blob
      })
      .then(blob => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `DTE.33.${selectedRow.numDOC}.${fileType}` //suggestedFilename || 'downloaded_file'; // Set the desired filename
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a); // Clean up the temporary element
        URL.revokeObjectURL(url); // Clean up the Blob URL
      })
      .catch(error => {
        console.error('Error downloading file:', error);
        // Optionally display an error message to the user
      })
      .finally(() => {
        setLoading(false);
      })
  }
  return (
    <CustomAppLayout
      toolsOpen={drawerOpen}
      onToolsChange={({ detail }) => setDrawerOpen(detail.open)}
      tools={


        <Drawer header="">
          <div>
            {selectedRow ? (

              <>
                <h3>Documento #{selectedRow.numDOC}</h3>
                <KeyValuePairs
                  columns={2}
                  items={[
                    {
                      label: "Nº Documento",
                      value: selectedRow.numDOC
                    },
                    {
                      label: "Neto",
                      value: new Intl.NumberFormat('es-CL', {
                        style: 'currency',
                        currency: 'CLP',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(selectedRow.neto)
                    },
                    {
                      label: "IVA",
                      value: new Intl.NumberFormat('es-CL', {
                        style: 'currency',
                        currency: 'CLP',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(selectedRow.iva)
                    },
                    {
                      label: "Bruto",
                      value: new Intl.NumberFormat('es-CL', {
                        style: 'currency',
                        currency: 'CLP',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }).format(selectedRow.bruto)
                    },
                    {
                      label: "Emisión",
                      value: (
                        <>
                          <Icon name='status-pending' />{' '}
                          Vencimiento {selectedRow.fechaVencimiento}
                        </>
                      ),
                      info: selectedRow.fechaEmision
                    },
                    selectedRow.fechaPago !== "" ? {
                      label: "Pagada",
                      value: (
                        <>
                          {selectedRow.fechaPago}
                        </>
                      )

                    } : null,
                    selectedRow.fechaPago === "" && selectedRow.dueDays > 0 ? {
                      label: (<>Estado <Icon name='status-warning' variant="error"></Icon></>),
                      value: (
                        <>
                          Vencida hace {selectedRow.dueDays} {selectedRow.dueDays === 1 ? 'día' : 'dias'}
                        </>
                      )
                    } : null,
                    selectedRow.fechaPago === "" && selectedRow.dueDays <= 0 ? {
                      label: (<>Estado <Icon name='status-info' variant="link"></Icon></>),
                      value: (
                        <>
                          Pendiente de pago
                        </>
                      )
                    } : null,
                  ].filter(Boolean) as { label: string; value: any }[]
                  }
                />
                <div style={{ height: '20px' }}></div>
                <SpaceBetween size='xs' direction="vertical">
                  <Button variant="primary" onClick={() => handleEmail()} iconName='envelope' fullWidth>Enviar</Button>
                  <SpaceBetween size='xs' direction="horizontal">
                    <Button variant="normal" onClick={() => handleDownload('pdf')} iconName='download' >PDF</Button>
                    <Button variant="normal" onClick={() => handleDownload('xml')} iconName='download' >XML</Button>
                  </SpaceBetween>
                </SpaceBetween>
              </>
            ) : (
              <p>No hay datos seleccionados.</p>
            )}
          </div>
        </Drawer>
      }

      contentType="form"
      breadcrumbs={
        <BreadcrumbGroup
          items={[
            { text: 'Inicio', href: '#home' },
            { text: 'Facturación', href: '#invoices' },
            { text: 'Emitidas', href: '#create-transcription-job' },
          ]}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <>

          <Modal
            visible={isModalEmailOpen}
            onDismiss={() => setIsModalEmailOpen(false)}
            header={emailHeader}
            size="small"
            footer={
              <Box float="right">
                <SpaceBetween direction="horizontal" size="xs">
                  <Button variant="link" onClick={() => setIsModalEmailOpen(false)}>Cancel</Button>
                  <Button variant="primary" onClick={() => btnSendEmail()} disabled={btnSendEmailDisabled} loading={btnSendEmailLoading}>Enviar</Button>
                </SpaceBetween>
              </Box>
            }
          >

            <SpaceBetween direction="vertical" size="xs">
              {admins.map((admin) => (
                (admin.idControl === 1394 && idControl !== 1394) || admin.notifications.indexOf('INVOICE') === -1 ?
                  null
                  : (
                    <Checkbox
                      key={admin.idControl}
                      onChange={handleChangeAdmins(admin)}
                      checked={selectedAdmins.includes(admin)}
                      description={admin.email}
                    >
                      {admin.displayName}
                    </Checkbox>
                  )
              ))}
            </SpaceBetween>
          </Modal>
          <Table
            stripedRows
            renderAriaLive={({ firstIndex, lastIndex, totalItemsCount }) =>
              `Displaying items ${firstIndex} to ${lastIndex} of ${totalItemsCount}`
            }
            onSelectionChange={handleSelectionChange}
            selectedItems={selectedItems}
            onRowClick={({ detail }) => handleRowClick(detail.item)}
            ariaLabels={{
              selectionGroupLabel: "Items selection",
              allItemsSelectionLabel: () => "select all",
              itemSelectionLabel: ({ selectedItems }, item) => item.idFacturacion.toString(),
            }}

            columnDefinitions={[
              {
                id: "numDOC",
                header: "DTE",
                cell: (item) => <Link href={`#invoices/view?id=${item.idFacturacion}`}>{item.numDOC}</Link>,
                width: 70,
                minWidth: 65,
                //sortingField: "numDOC",
                isRowHeader: true,
              },
              {
                id: "fechaEmision",
                header: "Emisión",
                cell: (item) => item.fechaEmision,
                //sortingField: "bruto",
              },
              {
                id: "bruto",
                header: "Total",
                cell: (item) => {
                  const amountFormatted = new Intl.NumberFormat('es-CL', {
                    style: 'currency',
                    currency: 'CLP',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  }).format(item.bruto);
                  return amountFormatted; // Return the formatted value
                },
                //sortingField: "bruto",
              },
              {
                id: "status",
                header: "Estado",
                maxWidth: 50,
                cell: (item) => {
                  if (item.status === 'V') {
                    return (
                      <>
                        <Icon name="status-warning" variant="error" ariaLabel="Vencida" />
                        {' '}
                        {item.dueDays === 0 ? 'Hoy' : `${item.dueDays} día${item.dueDays === 1 ? '' : 's'}`}
                      </>
                    );
                  } else if (item.status === 'C') {
                    return (
                      <>
                        <Icon name="status-positive" variant="success" ariaLabel='Pagada'></Icon>
                      </>)
                  } else if (item.status === 'P') {

                    return (
                      <>
                        <Icon name="status-pending" variant="warning" ariaLabel='Pagada'></Icon>
                      </>
                    )
                  }
                  return null;
                },
                //sortingField: "bruto",
              },
            ]}
            items={paginatedInvoices}
            selectionType="multi"
            trackBy="idFacturacion"
            empty={
              <Box margin={{ vertical: "xs" }} textAlign="center" color="inherit">
                <SpaceBetween size="m">
                  <b>No tiene documentos tributarios registradas</b>
                </SpaceBetween>
              </Box>
            }
            filter={
              <TextFilter
                filteringText={filteringText}
                onChange={({ detail }) => {
                  setFilteringText(detail.filteringText);
                  setCurrentPageIndex(1);
                }}
              />
            }
            pagination={
              <Pagination
                currentPageIndex={currentPageIndex}
                pagesCount={Math.ceil(filteredInvoices.length / pageSize)}
                onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
              />
            }

            preferences={
              <CollectionPreferences
                title="Preferencias"
                confirmLabel="Confirmar"
                cancelLabel="Cancelar"
                preferences={{
                  pageSize: 10,
                  contentDisplay: [
                    { id: "movil", visible: true },
                    { id: "displayName", visible: true },
                    { id: "accesos", visible: true },
                    { id: "unidad", visible: true }
                  ]
                }}
                pageSizePreference={{
                  title: "Paginación",
                  options: [
                    { value: 10, label: "10 items" },
                    { value: 20, label: "20 items" }
                  ]
                }}
                wrapLinesPreference={{}}
                stripedRowsPreference={{}}
                contentDensityPreference={{

                }}
                contentDisplayPreference={{
                  options: [
                    {
                      id: "movil",
                      label: "Movil",
                      alwaysVisible: true
                    },
                    { id: "displayName", label: "Nombre" },
                    { id: "unidad", label: "Unidad" },
                    { id: "accesos", label: "Accesos" }
                  ]
                }}
                stickyColumnsPreference={{
                  firstColumns: {
                    title: "Fijar primera columna(s)",
                    description:
                      "Mantener la primera columna(s) visibles mientras se hace scroll horizonal en el contenido de la tabla.",
                    options: [
                      { label: "Ninguno", value: 0 },
                      { label: "Primera columna", value: 1 },
                      { label: "Primeras dos columna", value: 2 }
                    ]
                  },
                  lastColumns: {
                    title: "Fijar última columna",
                    description:
                      "Keep the last column visible while horizontally scrolling the table content.",
                    options: [
                      { label: "Ninguno", value: 0 },
                      { label: "Última columna", value: 1 }
                    ]
                  }
                }}
              />
            }
            header={
              <Header
                counter={
                  selectedItems.length
                    ? "(" + selectedItems.length + "/" + invoices.length + ")"
                    : ""
                }
                actions={
                  <SpaceBetween direction="horizontal" size="xs">
                    <ButtonDropdown
                      items={[
                        {
                          text: "Enviar por correo",
                          id: "email",
                          disabled: false,

                        },
                        {
                          text: "Descargar",
                          id: "download",
                          disabled: false,
                        },
                      ]}
                      disabled={btnActionDisable}
                      onItemClick={handleDownloadMulti}
                    >
                      Acciones
                    </ButtonDropdown>
                  </SpaceBetween>
                }
              >
              </Header>
            }
          />

        </>
      }
    />
  );
};
